import { Box, Text, Heading } from "@chakra-ui/react";

const About = (): JSX.Element => {
  return (
    <Box width={{ base: "100%", md: "50%" }} display={"inline-block"}>
      <Box width={"100%"} textAlign={"center"} marginTop={3}>
        <Heading size={"lg"}>Who I am</Heading>
      </Box>
      <Text marginTop={6} textAlign={"justify"}>
        Experienced Frontend Engineer with 5 years of expertise in building
        scalable, high-performance web apps. Proficient in modern JavaScript
        frameworks like React and Next.js, with a strong focus on writing
        maintainable, testable code. Proven track record collaborating with
        cross-functional teams and leading projects from design to deployment.
        Passionate about creating intuitive, responsive user interfaces that
        enhance user experience.
      </Text>
    </Box>
  );
};

export default About;
